import React, { useState, useEffect, useRef } from "react";
import CountUp from "react-countup";
import "./progress.css";
import { progress } from "./data";

const Progress = () => {
  const [counterOn, setCounterOn] = useState(false);
  const sectionRef = useRef();

  useEffect(() => {
    const currentRef = sectionRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => setCounterOn(entry.isIntersecting),
      { threshold: 0.5 }
    );

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <section className="progres" ref={sectionRef}>
      <div className="progres-container">
        <div className="title">
          <h1>
            Discover Our Key Digital
            <span className="title-word"> Progress</span>
          </h1>
        </div>
        <div className="cards-container">
          {progress.map((card) => {
            const numericValue = parseFloat(
              card.number.replace(/[^\d.-]/g, "")
            );
            return (
              <div className="box" key={card.id}>
                <div className="headline">
                  <div className="icon">
                    <img src={card.icon} alt={card.title} />
                  </div>
                  <div className="number">
                    {counterOn ? (
                      <h1>
                        {card.id === 2 && "+"}
                        {card.id === 3 && "%"}
                        <CountUp
                          start={0}
                          end={numericValue}
                          duration={2}
                          delay={0}
                        />
                        {card.id === 2 && "k"}
                      </h1>
                    ) : (
                      <h1>
                        {card.id === 2
                          ? `+0k`
                          : card.id === 3
                          ? `%0`
                          : `0${card.number.replace(/[0-9]/g, "")}`}
                      </h1>
                    )}
                  </div>
                </div>
                <div className="progress-title">
                  <h4>{card.title}</h4>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Progress;
